<template>
    <div class="allotDevice_account_mask"  v-if="addOk">
        <el-card class="allotDevice_account">
            <div slot="header" class="clearfix" style="text-align:center;">
                <h4 style="margin-bottom: 0;">待分配设备：{{myAllotParams}}</h4>
                <span style="line-height: 36px;">可分配用户列表</span>
            </div>
            <div class="resourseContent">
                <el-table
                v-loading="loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                :row-style="grayRow"
                border
                height="460"
                fit
                style="width: 100%">
                <el-table-column
                    prop="code"
                    header-align="center"
                    width="65"
                    label="编号">
                </el-table-column>
                <el-table-column
                    prop="loginAccount"
                    header-align="center"
                    width="128"
                    label="登录账号">
                </el-table-column>
                 <el-table-column
                    prop="accountLevel"
                    header-align="center"
                    width="108"
                    label="账号级别">
                    <template scope="scope">
                        <span v-if="scope.row.accountLevel==0">超级管理员</span>
                        <span v-if="scope.row.accountLevel==1">代理商</span>
                        <span v-if="scope.row.accountLevel==2">设备主</span>
                        <span v-if="scope.row.accountLevel==3">维护人员</span>
                        <span v-if="scope.row.accountLevel==4">商户</span>
                        <span v-if="scope.row.accountLevel==5">销售</span>
                    </template>
                </el-table-column>
                 <el-table-column
                    prop="linkMan"
                    header-align="center"
                    min-width="100"
                    label="联系人">
                </el-table-column>
                 <el-table-column
                    prop="linkTel"
                    header-align="center"
                    width="128"
                    label="联系电话">
                </el-table-column>
                 <el-table-column
                    prop="status"
                    header-align="center"
                    width="65"
                    label="状态">
                    <template scope="scope">
                        <el-tag :type="scope.row.status === '已销户' ? 'danger' : 'success'"
                        close-transition>{{scope.row.status}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    width="100"
                    label="操作">>
                    <template scope="scope">
                        <el-button type="text" size="small" @click="allotTo(scope.row.code,scope.row.accountLevel)" :disabled="scope.row.accountLevel!==2&&scope.row.accountLevel!==1">分配设备</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
            <span @click="boxClose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
        </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      props: ['addShow', 'allotParams', 'deviceId'],
      data () {
        return {
          labelPosition: 'right',
          loading: true,
          pageNo: 1,
          pageSize: 10,
          pageTotal: 0,
          deviceData: []
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myAllotParams: function () {
          return this.allotParams
        },
        myAllotDeviceId: function () {
          return this.deviceId
        }
      },
      created: function () {
        this.getUserList()
      },
      methods: {
        boxClose () {
          this.$emit('closeAllotAccount', false)
        },
        getUserList () {
          var _this = this
          var params = {
            pageNo: _this.pageNo,
            pageSize: _this.pageSize
          }
          $axios.get('/custom/getList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    code: itemData.id,
                    loginAccount: itemData.user_name,
                    accountLevel: itemData.user_type,
                    linkMan: itemData.nickName,
                    linkTel: itemData.user_name,
                    status: itemData.status === 0 ? '正常' : '已销户',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
              _this.loading = false
            } else {
            }
          })
        },
        grayRow (row, rowIndex) {
          if (row.accountLevel !== 2 && row.accountLevel !== 1) {
            return 'color:#bbb'
          }
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.getUserList()
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.getUserList()
        },
        allotTo (code, accountLevel) {
          var that = this
          var params = {
            deviceId: that.myAllotDeviceId,
            userId: code
          }
          that.$confirm('是否确认分配设备给此账号？', '确认分配', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            $axios.get('/device/assignedDevice', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.$message({
                  message: '分配设备成功',
                  type: 'success'
                })
              } else {
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        }
      }
    }
</script>
<style lang="scss">
  .allotDevice_account_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  
      .allotDevice_account {
        min-height: 550px;
        width: 850px;
        top: 13%;
        left: 53%;
        z-index: 101;
        margin-left: -500px;
        position: fixed;

        .el-card__header {
            padding: 10px
        }
        .el-tabs__header {
            margin-bottom: 0;
        }
      }
  }
</style> 


// WEBPACK FOOTER //
// src/page/deviceMgr/allotDevice.vue